import { Outlet } from "react-router-dom";

const Condition = () => {

  return <Outlet />
}

export default Condition;